import { ovl, SYSAction } from "../../../../_ovlclient/src"
import { LanguageSet } from "../../../../_ovlclient/src/global/globalapi"
import type {
  HookTableAfterDelete_Type,
  HookTableAfterSave_Type,
  HookTableCustomSort_ReturnType,
  HookTableCustomSort_Type,
  HookTableInit_Type,
  HookTableSaveError_Type,
} from "../../../../_ovlclient/src/global/hooks"

import { SYSColumnDef } from "../../../../_ovlclient/src/library/table/tableapi"
import { ValidationsAdd } from "../../../src/library/forms/validatorsapi"
import { SnackAdd } from "../../../src/library/snackapi"
import type { TranslationType } from "./tabledef"

const HookTableInit: SYSAction<HookTableInit_Type> = (value, { global }) => {
  if (value.context !== "before") {
    return
  }
  if (value.tableDef.id === "SYSTranslation") {
    let state = global.getState()
    if (state.ovl.app.backendType === "SAP") {
      value.tableDef.database.dataIdField = "Code"
      value.tableDef.database.dbInsertMode = "UDTAutoGUIDBoth"
    }

    let colTemplate: SYSColumnDef = {
      order: 30,
      ui: {
        labelTranslationKey: "SYSTranslationColXX",
        thGroupTranslationKey: "SYSTranslationGroupColTranslations",
      },
      sortable: true,
      control: "textarea",
      nullHandling: { enabled: true },
    }
    let languageState = state.ovl.language
    let cols = languageState.availableTranslations.reduce((val, m) => {
      let col: SYSColumnDef = JSON.parse(JSON.stringify(colTemplate))
      col.ui.labelTranslationKey = `SYSTranslationCol${m}`
      col.nullHandling = {
        enabled: m !== languageState.translationFallbackLanguage,
      }
      val[`U_${m}`] = col
      return val
    }, {})
    value.tableDef.columns = Object.assign(value.tableDef.columns, cols)
  }
}

const HookTableSaveError: SYSAction<HookTableSaveError_Type> = (value) => {
  /* <Test Offline Handling>
  /* Keep it here for testing
  We handle any issues the OfflineHandler encounters while saving
  By returning "Handled" we signalize that OfflineHandler does not need
  To take further actions (Populating offline.error)
  */
  if (value.isOfflineRetry) {
    SnackAdd(`Offline Save Error:  ${value.rowFnResult.text}`, "Error")
    return { resolve: "Handled" }
  }
  /*</Test Offline Handling>*/
  if (value.rowFnResult.code === "UniqueKeyViolation") {
    // Integrity Error
    // In this case most probably because Group and Code are not unique

    ValidationsAdd(
      [
        value.formState.fields["U_TransGroup"],
        value.formState.fields["U_TransCode"],
      ],
      "SYSTranslationTextNotUnique",
      "Validate",
      {
        validation: {
          summaryGroup: "ValidationKey",
          summaryDisplayType: "Always",
        },
        setFocus: true,
      }
    )
  }
}
const HookTableCustom_Main_Sort: SYSAction<
  HookTableCustomSort_Type,
  HookTableCustomSort_ReturnType
> = (value) => {
  let valA = <TranslationType>value.data[value.a].U_TransGroup
  let valB = <TranslationType>value.data[value.b].U_TransGroup
  if (valA > valB) {
    return 1
  } else if (valA < valB) {
    return -1
  } else {
    let valA = <TranslationType>value.data[value.a].U_TransCode
    let valB = <TranslationType>value.data[value.b].U_TransCode
    if (valA > valB) {
      return 1
    } else if (valA < valB) {
      return -1
    } else {
      return 0
    }
  }
}

const HookTableAfterSave: SYSAction<HookTableAfterSave_Type> = async (_) => {
  await debouncedLanguageSet()
}

const HookTableAfterDelete: SYSAction<HookTableAfterDelete_Type> = async (
  _
) => {
  await debouncedLanguageSet()
}

let debouncedLanguageSetTimer
const debouncedLanguageSet = async () => {
  if (debouncedLanguageSetTimer) {
    clearTimeout(debouncedLanguageSetTimer)
  }
  debouncedLanguageSetTimer = await setTimeout(async () => {
    await LanguageSet(ovl.getState().ovl.session.Language)
  }, 2000)
}

export let hooks = {
  HookTableAfterDelete,
  HookTableAfterSave,
  HookTableCustom_Main_Sort,
  HookTableSaveError,
  HookTableInit,
}
